module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<body>\n<table role="presentation" class="zmags_w" width="100%">\n    <tr>\n        <td>\n            <img src="' +
((__t = (transparentImg)) == null ? '' : __t) +
'" width="1" height="1" style="width: 1px; height: 1px;">\n            <table role="presentation" align="center" class="gmail_w" background="' +
((__t = (screenshotURL)) == null ? '' : __t) +
'" style="width:' +
((__t = (width+1)) == null ? '' : __t) +
'px;height:' +
((__t = (height+1)) == null ? '' : __t) +
'px;border:0;border-collapse:collapse; background-image: url(\'' +
((__t = (screenshotURL)) == null ? '' : __t) +
'\');background-size: 100% 100%;" cellpadding="0" cellspacing="0" border="0">\n                <tbody>\n                ';
 _.each(tableJSON, function(row) {
                        ;
__p += '<tr>';
 _.each(row, function(td, i) {
                                ;

 var opacity = getOpacityCssClass(td.hoverOpacity);
__p += '\n                                    <td\n                                        width="' +
((__t = (td.width)) == null ? '' : __t) +
'"\n                                        height="' +
((__t = (td.height)) == null ? '' : __t) +
'"\n                                        valign="top"\n                                        ';
 if (td.img) {
                                        ;
__p += 'background="' +
((__t = (td.img)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
 if (td.rowSpan>1) {
                                        ;
__p += 'rowspan="' +
((__t = (td.rowSpan)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
 if (td.colSpan>1) {
                                            ;
__p += 'colspan="' +
((__t = (td.colSpan)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
 if (opacity) {
                                            ;
__p += 'class="' +
((__t = (opacity)) == null ? '' : __t) +
'"';
};
__p += '\n                                        style="background-size: 100% 100%;';
 if (td.width) { ;
__p += 'width:' +
((__t = (td.width)) == null ? '' : __t) +
'px;';
};
__p += ' ';
 if (td.height) { ;
__p += 'height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;';
};
__p += 'border-collapse:collapse;mso-line-height-rule:exactly;line-height:25%;"\n                                    >\n                                    ';
 if (td.img) {
                                        ;
__p += '<!--[if mso]>\n                                        ';
if(td.actionUrl){;
__p += '\n                                               <table width="' +
((__t = (td.width)) == null ? '' : __t) +
'" style="border-collapse:collapse;" cellpadding="0" cellspacing="0" border="0">\n                                                   <tr style="display:grid;max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;float:left;">\n                                                       <td><a\n                                                            ';
if(td.type==="button"){;
__p += ' role="button" ';
};
__p += '\n                                                            ';
if(td.altText){;
__p += ' aria-label="' +
((__t = (td.altText)) == null ? '' : __t) +
'"';
};
__p += '\n                                                            ';
if(td.label){;
__p += ' title="' +
((__t = (td.label)) == null ? '' : __t) +
'"';
};
__p += '\n                                                            href="' +
((__t = (td.actionUrl)) == null ? '' : __t) +
'" target="_blank">\n                                                                <img width="100%" alt src="' +
((__t = (td.img)) == null ? '' : __t) +
'" />\n                                                            </a>\n                                                       </td>\n                                                   </tr>\n                                               </table>\n                                        ';
}else{;
__p += '\n                                           <v:image xmlns:v="urn:schemas-microsoft-com:vml" style="behavior:url(#default#VML);display:block;position:absolute;width:' +
((__t = (td.width+0.13)) == null ? '' : __t) +
'px;height:' +
((__t = (td.height+0.13)) == null ? '' : __t) +
'px;top:0;left:0;" src="' +
((__t = (td.img)) == null ? '' : __t) +
'"/>\n                                        ';
};
__p += '\n                                        <![endif]-->';
}
                                    ;
__p += '\n                                    <!--[if !mso]><!-- -->\n                                    ';
if(td.actionUrl){;
__p += '\n                                        <a\n                                        ';
if(td.type==="button"){;
__p += ' role="button" ';
};
__p += '\n                                        ';
if(td.altText){;
__p += ' aria-label="' +
((__t = (td.altText)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
if(td.label){;
__p += ' title="' +
((__t = (td.label)) == null ? '' : __t) +
'"';
};
__p += '\n                                        style="display:block;width:' +
((__t = (td.width)) == null ? '' : __t) +
'px; height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;" ';
if(td.hoverToggleImage){;
__p += 'class="rollover"';
};
__p += ' href="' +
((__t = (td.actionUrl)) == null ? '' : __t) +
'">\n                                        ';
}
                                            else if(td.hoverToggleImage){;
__p += '<span style="display:block;width:' +
((__t = (td.width)) == null ? '' : __t) +
'px; height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;" class="rollover">';
};
__p += '\n                                            <div style="width:' +
((__t = (td.width)) == null ? '' : __t) +
'px; height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;">\n                                                ';
if(td.hoverToggleImage){;
__p += '\n                                                    <img style="max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; display:none; width:' +
((__t = (td.width+0.15)) == null ? '' : __t) +
'px;height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;border:0;"\n                                                        src="' +
((__t = (cloudinaryUrl)) == null ? '' : __t) +
'/f_auto,q_auto/' +
((__t = (util.getFileNameWithExtension(td.hoverToggleImage))) == null ? '' : __t) +
'"\n                                                        alt=""\n                                                    />\n                                                ';
};
__p += '\n                                            </div>\n                                        ';
if(td.actionUrl){;
__p += '</a>';
}
                                        else if(td.hoverToggleImage){;
__p += '</span>';
};
__p += '\n                                    <![endif]-->\n                                    </td>';
});
                        ;
__p += '</tr>';
});
                ;
__p += '</tbody>\n            </table>\n        </td>\n    </tr>\n</table>\n</body>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/email/renderer/EmailRenderer.tpl
// module id = 2927
// module chunks = 0